import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

// Rota /:code — captura o slug do referral e redireciona para o cadastro.
// Rotas conhecidas (login, dashboard, admin, etc.) são tratadas antes desta.
const KNOWN_ROUTES = new Set([
  "login", "cadastro", "dashboard", "matriz", "indicacoes", "beneficios",
  "admin", "aguardando-ativacao", "esqueci-senha", "redefinir-senha",
]);

export default function ReferralLink() {
  const { code } = useParams();
  const navigate = useNavigate();
  useEffect(() => {
    if (!code || KNOWN_ROUTES.has(code.toLowerCase())) {
      navigate("/", { replace: true });
      return;
    }
    navigate(`/cadastro?ref=${encodeURIComponent(code.toLowerCase())}`, { replace: true });
  }, [code, navigate]);
  return null;
}
